import React from 'react';
import KeyboardIcon from './keyboard-regular-full.svg';

function LeadManualInputIcon(props) {
    const { onClick } = props;

    return (
        <div className={'icon'}>
            <KeyboardIcon onClick={onClick} />
        </div>
    );
}

export default LeadManualInputIcon;
